// extracted by mini-css-extract-plugin
export default {"companyContainer":"VM-z","companyImage":"WM-z","container":"XM-z","heading":"YM-z","darkText":"ZM-z","smallHeading":"_M-z","darkBackground":"aN-z","whiteBackground":"bN-z"};